var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.priority)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltipText,
    delay: { show: 1500, hide: 0 },
    hideOnClick: true,
  }),expression:"{\n    content: tooltipText,\n    delay: { show: 1500, hide: 0 },\n    hideOnClick: true,\n  }"}],staticClass:"shrink-0 rounded-sm inline-flex"},[_c('img',{staticClass:"w-4 h-4",attrs:{"src":_vm.priorityBadgeIcon,"alt":"Priority Icon"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }